import { Home } from './home/Home'
import { Settings } from './settings/Settings'
import { Policy } from './policy/Policy'

export const AppPages = {
  Home,
  Settings,
  Policy
}
